// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".product-select[data-v-588d7be6]{color:var(--body-color);display:flex;flex-direction:column;min-height:100vh;position:relative}.product-select__header[data-v-588d7be6]{text-transform:uppercase}.product-select__body[data-v-588d7be6]{flex:1 0 auto;max-width:586px}.product-select__back-button[data-v-588d7be6]{color:inherit;font-size:24px;line-height:1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
